module.exports = __webpack_public_path__ + "static/ilo-logo-8d52bc3a847d852d9dda9c3ecb3bf478.png";